import VisualizationView from './VisualizationView';
import './VisualizationView.scss';

export default VisualizationView;
